import React, { memo, useState } from 'react';
import DatePicker from 'react-datepicker';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { customDateHeader } from '../../../containers/Pages/Edd/EddUtils';

const ScheduleImport = memo(props => {
  const {
    show,
    data,
    title,
    subtitle,
    setShowScheduleImport,
    scheduleImportButtonText,
    handleScheduleImport,
  } = props;
  const [dateArr, setDateArr] = useState(new Array(30).fill(null));
  const [time, setTime] = useState(new Array(30).fill(''));

  return show ? (
    <div
      className="h-screen w-screen fixed top-0 left-0 backdrop-blur-sm  z-50 flex justify-center items-center transition-all duration-1000 ease-in-out"
      style={{ zIndex: 1001 }}
    >
      <div className="w-3/6  bg-white rounded-md z-50 shadow-2xl opacity-100 duration-1000 ease-in-out">
        <div className="flex justify-end">
          <button
            type="button"
            className="cursor-pointer transition-transform duration-700 hover:rotate-90 hover:text-primary text-dark-night"
            onClick={() => setShowScheduleImport(false)}
          >
            <i className="material-icons text-[24px] m-4 !text-inherit">close</i>
          </button>
        </div>
        <h2 className=" mt-4 font-bold text-lg text-center">{title}</h2>
        <p className="text-sm mt-1 text[#ff8f00] supported-files text-center">{subtitle}</p>

        {data.map((el, i) => (
          <div key={uuidv4()} className="mt-6">
            <div className="flex justify-center mt-2">
              <div
                type="button"
                className=" text-gray-800  border focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 h-8 text-center me-2 mb-2
                        flex items-center justify-center"
              >
                <p className="font-bold text-inherit mr-4">{el}</p>
              </div>
              <div className="edd">
                <DatePicker
                  selected={dateArr[i]}
                  onChange={date => {
                    const newDateArr = [...dateArr];

                    newDateArr[i] = date;
                    setDateArr(newDateArr);
                  }}
                  formatWeekDay={nameOfDay => nameOfDay.substr(0, 1)}
                  renderCustomHeader={customDateHeader}
                  popperPlacement="top"
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  placeholderText="dd/mm/yyyy"
                  timeIntervals={15}
                  timeCaption="On time"
                  onChangeRaw={() => {}}
                  disabled={false}
                  isClearable={() => {}}
                />
              </div>
              <input
                type="time"
                onChange={e => {
                  const newTimeArr = [...time];

                  newTimeArr[i] = e.target.value;
                  setTime(newTimeArr);
                }}
                value={time[i]}
                placeholder="HH:MM"
                pattern="^([0-1]\d|2[0-3]):([0-5]\d)$"
                id="time-picker"
                className=" text-center bg-background ml-2 rounded-md accent-black focus:outline-gray-500 transition-all duration-500 outline-gray-300 border-gray-300 border-2  h-8   appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
              />
            </div>
          </div>
        ))}

        <div className="flex justify-center pb-4  mt-8">
          <button
            type="button"
            className="bg-orange-500 active:bg-orange-300 hover:scale-x-105 hover:scale-y-105 transition duration-500 z-30 shadow-md  w-32 h-12 rounded-lg text-white text-sm font-bold px-2 hover:animate-pulseOpacity"
            onClick={async () => {
              let importDates = dateArr.filter(el => el != null);
              const importTimes = time.filter(el => el !== '');

              if (importTimes.length !== data.length) {
                alert('the time field cannot be blank for any selected file');

                return;
              }

              if (importDates.length !== data.length) {
                alert('You must choose a date and a time for all selected files');

                return;
              }

              importDates = importDates.map((date, i) => {
                const timeValue = importTimes[i] ? importTimes[i].split(':') : ['00', '00'];
                const hours = Number.parseInt(timeValue[0], 10);
                const minutes = Number.parseInt(timeValue[1], 10);

                // Set the time on the date object
                date.setHours(hours, minutes, 0, 0);

                return date;
              });

              await handleScheduleImport(importDates, setDateArr);
            }}
          >
            {scheduleImportButtonText}
          </button>
        </div>
      </div>
    </div>
  ) : null;
});

ScheduleImport.propTypes = {
  show: PropTypes.bool,
  data: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  setShowScheduleImport: PropTypes.func,
  scheduleImportButtonText: PropTypes.string,
  handleScheduleImport: PropTypes.func,
};

export default ScheduleImport;
